<template>
  <div class="card">
    <div class="card-header">
      <i class="fa fa-align-justify"></i>
      {{ $t('clients.header')}}
    </div>
    <div class="card-actions d-flex justify-content-between">
      <a href class="btn btn-secondary btn-sm" @click.prevent="toggleFiltersVisibility()">
        <span v-if="filtersVisible">Ukryj filtry</span>
        <span v-if="!filtersVisible">Pokaż filtry</span>
      </a>
      <form action="/api/clients/exports/list"
            class="d-inline-block"
            target="_blank"
            method="GET">
        <span class="text-muted">Uwaga! Plik zawiera do 10 tyś rekordów</span>
        <input name="qLastName" v-model="filters.qLastName" v-bind:disabled="!filters.qLastName" type="hidden"/>
        <input name="qFirstName" v-model="filters.qFirstName" v-bind:disabled="!filters.qFirstName"
               type="hidden"/>
        <input name="qPesel" v-model="filters.qPesel" v-bind:disabled="!filters.qPesel" type="hidden"/>
        <input name="qCity" v-model="filters.qCity" v-bind:disabled="!filters.qCity" type="hidden"/>
        <input name="qStreet" v-model="filters.qStreet" v-bind:disabled="!filters.qStreet" type="hidden"/>
        <input name="qApplicableLoyaltyCard" v-model="filters.qApplicableLoyaltyCard"
               v-bind:disabled="!filters.qApplicableLoyaltyCard" type="hidden"/>
        <input name="qLoyaltyCard" v-model="filters.qLoyaltyCard" v-bind:disabled="!filters.qLoyaltyCard"
               type="hidden"/>
        <input name="qZgodaNpdo" v-model="filters.qZgodaNpdo" v-bind:disabled="!filters.qZgodaNpdo"
               type="hidden"/>
        <input name="qZgodaNprd" v-model="filters.qZgodaNprd" v-bind:disabled="!filters.qZgodaNprd"
               type="hidden"/>
        <input name="qZgodaNoih" v-model="filters.qZgodaNoih" v-bind:disabled="!filters.qZgodaNoih"
               type="hidden"/>
        <input name="qZgodaEmail" v-model="filters.qZgodaEmail" v-bind:disabled="!filters.qZgodaEmail"
               type="hidden"/>
        <input name="qStatus" v-model="filters.qStatus" v-bind:disabled="!filters.qStatus" type="hidden"/>
        <button type="submit" class="btn btn-secondary btn-sm  ml-2">Pobierz xls</button>
      </form>
    </div>
    <div class="card-filters" v-if="filtersVisible">
      <form @submit.prevent="searchList()">
        <div class="row">
          <div class="form-group col-md-2">
            <label>Nazwisko</label>
            <input class="form-control" v-model="filters.qLastName" type="text"/>
          </div>
          <div class="form-group col-md-2">
            <label>Imiona</label>
            <input class="form-control" v-model="filters.qFirstName" type="text"/>
          </div>
          <div class="form-group col-md-2">
            <label>Pesel</label>
            <input class="form-control" v-model="filters.qPesel" type="text"/>
          </div>
          <div class="form-group col-md-2">
            <label>Miasto</label>
            <input class="form-control" v-model="filters.qCity" type="text"/>
          </div>
          <div class="form-group col-md-2">
            <label>Ulica</label>
            <input class="form-control" v-model="filters.qStreet" type="text"/>
          </div>
          <div class="form-group col-md-2">
            <label>Karta do wydania</label>
            <select class="form-control" id="qApplicableLoyaltyCard" v-model="filters.qApplicableLoyaltyCard">
              <option value=""></option>
              <option value="yes">Tak</option>
              <option value="no">Nie</option>
            </select>
          </div>
          <div class="form-group col-md-2">
            <label>Karta lojalnościowa</label>
            <select class="form-control" id="qLoyaltyCard" v-model="filters.qLoyaltyCard">
              <option value=""></option>
              <option value="0">Brak</option>
              <option value="10">Brązowa</option>
              <option value="20">Srebrna</option>
              <option value="30">Złota</option>
            </select>
          </div>
          <div class="form-group col-md-2">
            <label for="qZgodaNpdo">Zgoda na przetwarzanie danych</label>
            <select class="form-control" id="qZgodaNpdo" v-model="filters.qZgodaNpdo">
              <option value=""></option>
              <option value="1">TAK</option>
              <option value="0">NIE</option>
            </select>
          </div>
          <div class="form-group col-md-2">
            <label for="qZgodaNprd">Zgoda na wyśw. danych i rach.</label>
            <select class="form-control" id="qZgodaNprd" v-model="filters.qZgodaNprd">
              <option value=""></option>
              <option value="1">TAK</option>
              <option value="0">NIE</option>
            </select>
          </div>
          <div class="form-group col-md-2">
            <label for="qZgodaNoih">Zgoda marketingowa</label>
            <select class="form-control" id="qZgodaNoih" v-model="filters.qZgodaNoih">
              <option value=""></option>
              <option value="1">TAK</option>
              <option value="0">NIE</option>
            </select>
          </div>
          <div class="form-group col-md-2">
            <label for="qZgodaEmail">Zgoda Email</label>
            <select class="form-control" id="qZgodaEmail" v-model="filters.qZgodaEmail">
              <option value=""></option>
              <option value="1">TAK</option>
              <option value="0">NIE</option>
            </select>
          </div>
          <div class="form-group col-md-2">
            <label for="qStatus">Status</label>
            <select class="form-control" id="qStatus" v-model="filters.qStatus">
              <option value="active">Aktywny</option>
              <option value="archived">Zarchiwizowany</option>
            </select>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-12">
            <button type="submit" class="btn btn-primary">Szukaj</button>

            <button type="button" @click="clearFilters()" class="btn btn-link">Wyczyść filtry</button>
          </div>
        </div>
      </form>
    </div>
    <div class="card-body">
      <table class="table table-responsive-sm table-bordered table-striped">
        <thead>
        <tr>
          <th scope="col">{{ $t('clients.clientId')}}</th>
          <th scope="col" @click="setOrderBy('lastName')">{{ $t('clients.fullName') }}</th>
          <th scope="col" @click="setOrderBy('street')">{{ $t('clients.address') }}</th>
          <th scope="col" @click="setOrderBy('city')">{{ $t('clients.city') }}</th>
          <th scope="col">{{ $t('clients.pesel') }}</th>
          <th scope="col">Karta lojalnościowa</th>
          <th scope="col">Typ konta</th>
          <th scope="col">{{ $t('common.actions') }}</th>
        </tr>
        </thead>
        <tbody>
        <tr class="loading" v-if="isLoading" v-bind:key="item"
            v-for="item in $store.state[paramsName].pageSize">
          <td v-bind:data-id="item"></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr v-if="!totalCount && !isLoading">
          <td colspan="8">
            Brak rekordów spełniających podane kryteria.
            Zmień lub <a href @click.prevent="clearFilters()">wyczyść filtry</a>.
          </td>
        </tr>
        <tr v-for="client in clients" v-if="!isLoading" :key="client.clientId" class="client-row">
          <td>{{ client.clientId}}</td>
          <td>{{ client.fullName }}</td>
          <td>{{ client.address }}</td>
          <td>{{ client.city }}</td>
          <td>{{ client.pesel }}</td>
          <td>{{client.actualLoyaltyGroup}}</td>
          <td>
                  <span v-if="client.parentClientId">
                    <span class="badge badge-secondary mr-2">Subkonto</span>
                  </span>
            <span v-if="!client.parentClientId">
                    <span class="badge badge-success mr-2">Konto główne</span>
                  </span>
          </td>
          <td>
            <a href @click.prevent="goToDetails(client)">Szczegóły</a>
            <router-link class="ml-2" :to="{name: 'clientMerge', params: {clientId: client.clientId}}"
                         v-has-permissions="50">
              Połącz
            </router-link>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <list-pager
        v-bind:params-name="paramsName"
        v-bind:total-count="totalCount"
        @reload="loadItems()">
    </list-pager>
  </div>
</template>

<script>
  import clients from '@Service/clients';
  import { router } from '@Router';
  import { toastError, listMixin } from '../helpers';
  import listPager from '@Component/list-pager';

  export default {
    data: function () {
      return {
        paramsName: 'clientsParams',
        clients: [],
        totalCount: 0,
        filters: {},
        filtersVisible: false,
        isLoading: false,
      };
    },
    mixins: [
      listMixin,
    ],
    components: {
      listPager,
    },
    methods: {
      goToDetails: (client) => {
        const { clientId } = client;
        router.push({ name: 'clientDetails', params: { clientId } });
      },
      loadItems: function () {
        this.isLoading = true;
        return clients.getClients(this.$store.state[this.paramsName])
          .then(response => {
            this.totalCount = parseInt(response.headers.get('totalCount'), 10);
            this.clients = response.data;
          })
          .catch(toastError)
          .finally(() => this.isLoading = false);
      },
      searchList: function () {
        this.$store.commit('setParams', {
          paramsName: this.paramsName,
          params: {
            ...this.filters,
            offset: 0,
          },
        });

        this.loadItems();
      },
      clearFilters: function () {
        this.filters = {
          qLastName: '',
          qFirstName: '',
          qPesel: '',
          qCity: '',
          qZgodaNpdo: '',
          qZgodaNoih: '',
          qZgodaEmail: '',
          qZgodaNprd: '',
          qStreet: '',
          qApplicableLoyaltyCard: '',
          qLoyaltyCard: '',
          qStatus: 'active',
        };
        this.searchList();
      },
    },
    mounted: function () {
      this.filters = {
        qCity: this.$store.state[this.paramsName].qCity,
        qZgodaNpdo: this.$store.state[this.paramsName].qZgodaNpdo,
        qZgodaNoih: this.$store.state[this.paramsName].qZgodaNoih,
        qZgodaEmail: this.$store.state[this.paramsName].qZgodaEmail,
        qZgodaNprd: this.$store.state[this.paramsName].qZgodaNprd,
        qStreet: this.$store.state[this.paramsName].qStreet,
        qPesel: this.$store.state[this.paramsName].qPesel,
        qFirstName: this.$store.state[this.paramsName].qFirstName,
        qLastName: this.$store.state[this.paramsName].qLastName,
        qStatus: this.$store.state[this.paramsName].qStatus,
        qApplicableLoyaltyCard: this.$store.state[this.paramsName].qApplicableLoyaltyCard,
        qLoyaltyCard: this.$store.state[this.paramsName].qLoyaltyCard,
      };
      this.filtersVisible = this.$store.state[this.paramsName].filtersVisible;
      this.loadItems();
    },
  };
</script>
<style></style>